var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apolar-menu-options"},[_c('i',{staticClass:"fa fa-caret-up",attrs:{"aria-hidden":"true"}}),_c('ul',_vm._l((_vm.menu_options),function(menu,key){return _c('li',{key:key},[_c('a',{attrs:{"href":menu.link}},[_vm._v(_vm._s(menu.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }